export default __webpack_public_path__ + "static/media/master-card.3d78b982.svg";